import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Route, Routes } from 'react-router-dom';
import { Link, Typography } from '@mui/material';
import { createTheme , ThemeProvider } from '@mui/material/styles';

import {  AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useIsAuthenticated } from "@azure/msal-react";
import * as authActions from './actions/auth';

import { Routes as AppRoutes } from './constants/routes';
import Layout from './components/layout/Layout';
import Home from './components/Home';
import Support from './components/support/Support';
import Notifications from './components/notifications/Notifications';

import { themeGreen } from './constants/theme';
import { selectTheme } from './reducers/theme';

import graphSettings from './config/graphSettings';

import './custom.css'

const setMsalContextAction = authActions.createSetMsalContextAction();
const getProfileAction = authActions.createGetProfileAction();

const savedTheme = JSON.parse(localStorage.getItem('sdxactivitiestheme')!);
const defaultTheme = savedTheme && savedTheme.palette ? createTheme ({ ...savedTheme}) : createTheme ({ ...themeGreen });

export default () => {

    const msalContext = useMsal();
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    
    React.useEffect(() => {
        dispatch(setMsalContextAction(msalContext));
    }, [isAuthenticated]);

    if (isAuthenticated) {
        dispatch(getProfileAction());
    }

    const userTheme = useSelector(selectTheme);
    let theme = defaultTheme;
    if (userTheme) {
        localStorage.setItem('sdxactivitiestheme', JSON.stringify(userTheme));
        theme = createTheme({...userTheme});
    }

    return (
        <ThemeProvider theme={theme}>
            <Layout>
				<AuthenticatedTemplate>
                    <Routes>
                        <Route path={AppRoutes.Home} element={<Home />} />
                        <Route path={AppRoutes.About} element={<div>About...</div>} />
                        <Route path={AppRoutes.Support} element={<Support />} />
                    </Routes>
				</AuthenticatedTemplate>
				<UnauthenticatedTemplate>
					<Typography>
						Bitte mit dem SDX Account <Link href="javascript:;;" onClick={() => msalContext.instance.loginRedirect({ scopes: graphSettings.scopes })}>anmelden</Link>.
					</Typography>
				</UnauthenticatedTemplate>             
                <Notifications />
            </Layout>
        </ThemeProvider>
    );
}